export default __webpack_public_path__ + "static/media/hht1_ep20_timeline_q02_a.b9a054a0.png";